import WebVideo from './WebVideo';
export default WebVideo;